export default __webpack_public_path__ + "static/media/BOTIKA.7103e717.png";